<template>
  <div v-if="isAdmin" class="chart-download" @click.stop>
    <el-dropdown trigger="click" @command="download">
      <button type="button" class="chart-download-btn" aria-label="下载" :disabled="disabled || busy">
        <i class="el-icon-download"></i>
      </button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="image">仅图片</el-dropdown-item>
        <el-dropdown-item command="data">仅数据</el-dropdown-item>
        <el-dropdown-item command="both">图片和数据</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { checkAdminSession } from '@/utils/adminSession';
import { exportChart, prefetchXlsx } from '@/utils/chartExport';

export default {
  name: 'ChartDownloadButton',
  props: {
    title: { type: String, default: '图表' },
    getChart: { type: Function, required: true },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      isAdmin: false,
      busy: false,
    };
  },
  created() {
    checkAdminSession().then((ok) => {
      if (this._isDestroyed) return;
      this.isAdmin = ok;
      if (ok) prefetchXlsx();
    });
  },
  methods: {
    async download(mode) {
      if (!this.isAdmin || this.busy || this.disabled) return;

      const chart = this.getChart();
      if (!chart) {
        this.$message.warning('图表尚未加载完成');
        return;
      }

      this.busy = true;
      try {
        await exportChart({
          chart,
          title: this.title,
          withWatermark: false,
          includeImage: mode === 'image' || mode === 'both',
          includeData: mode === 'data' || mode === 'both',
        });
      } catch (error) {
        this.$message.error(error.message || '下载失败，请稍后重试');
      } finally {
        this.busy = false;
      }
    },
  },
};
</script>

<style scoped>
.chart-download {
  position: absolute;
  top: 8px;
  right: 10px;
  z-index: 12;
}

.chart-download-btn {
  background: transparent;
  color: #c0c4cc;
  border: none;
  border-radius: 4px;
  padding: 4px;
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
}

.chart-download-btn:hover:not(:disabled) {
  color: #909399;
  background: transparent;
}

.chart-download-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
</style>
